import axios from "axios";
import * as helpers from "../../../../app/util/helpers";
import store from "../../../../redux/store";
import { API_ENDPOINTS } from "../../../util/constants";
import { getSessionUserId } from "../helpers";
import { actionTypes } from "../reducer";

export const getAgentWrapupTime = (dispatch) => {
  return 20;
};

export const shouldWaitTillWrapupTime = (dispatch) => {
  const w = true;
  return w;
};

export const initTicker = (dispatch) => {
  if (helpers.isAgent() || helpers.isSuperVisor()) {
    const hasAgentNums = hasAgentNumbers();
    if (!hasAgentNums) {
      getAgentNumbers(dispatch);
    }
  }
};

export const getAgentNumbers = async (dispatch) => {
  const url = API_ENDPOINTS.getAgentNumbers;
  try {
    const params = {};

    const response = await axios.get(url, { params: params });
    if (
      response &&
      response.data &&
      response.data.objects &&
      response.data.objects.length > 0
    ) {
      const session_agent_numbers = [];
      const objects = response.data.objects;

      if (objects && objects.length > 0) {
        objects.map((agent, i) => {
          session_agent_numbers.push(agent);
        });
      }

      if (dispatch)
        dispatch({
          type: "onSetAgentNumbers",
          payload: { session_agent_numbers: session_agent_numbers },
        });
      session_agent_numbers.map((agent, i) => {
        if (agent.id === getSessionUserId()) {
          if (agent.sip_url_flag) {
            if (dispatch)
              dispatch({
                type: "onSetTickerState",
                payload: {
                  sipAgent: agent,
                  session_agent: agent,
                  phone_switch_agent: { ...agent },
                  phone_switch_state: "sip",
                },
              });
          } else {
            if (dispatch)
              dispatch({
                type: "onSetTickerState",
                payload: {
                  phoneAgent: agent,
                  session_agent: agent,
                  phone_switch_agent: { ...agent },
                  phone_switch_state: "phone",
                },
              });
          }
        }
      });

      return session_agent_numbers;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getQueueName = async (q_uuid, dispatch) => {
  const url = API_ENDPOINTS.getQueueName;
  try {
    const params = {
      user_id: store.getState().auth.user.user_id,
      q_uuid: q_uuid,
    };
    const response = await axios.get(url, { params: params });
    if (response && response.data && response.data.q_name) {
      return response.data.q_name;
    }
  } catch (error) {
    console.error(error);
  }
  return "Unknown";
};
export const hasAgentNumbers = () => {
  const {
    ticker: { session_agent_numbers },
  } = store.getState();

  return session_agent_numbers && session_agent_numbers.length > 0
    ? true
    : false;
};

export const getCallSessionAgentUserId = () => {
  const {
    ticker: { session_agent },
  } = store.getState();

  if (!session_agent) {
    alert("CRITICAL session_agent not set.");
    console.error("TICKER", "CRITICAL session_agent not set.");
  }
  return session_agent.id;
};

export const getCallSessionAgent = () => {
  const {
    ticker: { session_agent },
  } = store.getState();

  if (!session_agent) {
    alert("CRITICAL session_agent not set.");
    console.error("TICKER", "CRITICAL session_agent not set.");
  }
  return session_agent;
};

export const getCallConferenceAgent = () => {
  const {
    ticker: { conference_agent },
  } = store.getState();

  if (!conference_agent) {
    console.error("TICKER", "CRITICAL conference_agent not set.");
  }
  return conference_agent;
};

export const getCallTransferAgent = () => {
  const {
    ticker: { transfer_agent },
  } = store.getState();

  if (!transfer_agent) {
    console.error("TICKER", "CRITICAL transfer_agent not set.");
  }
  return transfer_agent;
};

export const getCallTransferQueue = () => {
  const {
    ticker: { queue },
  } = store.getState();

  if (!queue) {
    console.error("TICKER", "CRITICAL queue not set.");
    return { name: "Unknown" };
  }
  return queue;
};

export const hasSIP = (agent) => {
  if (agent.sip_url_flag) {
    return true;
  }

  if (agent.backup_number) {
    return true;
  }
};

export const hasPhone = (agent) => {
  if (!agent.sip_url_flag) {
    return true;
  }

  if (agent.backup_number) {
    return true;
  }
};

export const getPhoneToggleState = (agent) => {
  if (!agent.sip_url_flag) {
    return "phone";
  } else {
    return "sip";
  }
};

export const getIsSipCall = (callEvent) => {
  const agent = getCallSessionAgent();
  if (agent && agent.sip_url_flag) {
    return true;
  }

  return false;
};

export const isAgentEvent = (event, dispatch) => {
  const {
    ticker: { session_agent_numbers },
  } = store.getState();
  if (!session_agent_numbers) return false;
  for (let i = 0; i < session_agent_numbers.length; i++) {
    const agent = session_agent_numbers[i];
    if (agent.sip_url_flag) {
      if (agent.phone === event["agent_number"]) {
        return true;
      }
    } else {
      let phone = agent.country_code + agent.phone;
      if (phone === event["agent_number"]) {
        return true;
      }
    }
  }

  return false;
};
